const PICKER_TYPES = new Set(['date', 'datetime-local', 'month', 'time'])

const PICKER_CONTAINER_SELECTOR =
  '.filters-panel, .filters, .filter-row, .roster-filters, .dialog-body, .form, .form-panel'

function shouldOpenPicker(input) {
  if (!(input instanceof HTMLInputElement)) return false
  if (!PICKER_TYPES.has(input.type)) return false
  if (input.disabled || input.readOnly) return false
  return !!input.closest(PICKER_CONTAINER_SELECTOR)
}

function triggerPicker(input) {
  if (typeof input.showPicker !== 'function') return
  try {
    input.showPicker()
  } catch {
    // Some browsers reject showPicker without user gesture or when already open.
  }
}

/** 供表单单个输入框 @click 复用（如活动编辑页） */
export function openNativeDatePicker(event) {
  const input = event?.target
  if (!(input instanceof HTMLInputElement)) return
  if (!PICKER_TYPES.has(input.type)) return
  if (input.disabled || input.readOnly) return
  triggerPicker(input)
}

/** 筛选区 / 弹窗表单 date 等：点击输入框任意区域打开原生选择器 */
export function installFilterDatePickerAutoOpen() {
  if (typeof document === 'undefined') return
  document.addEventListener('click', (event) => {
    if (shouldOpenPicker(event.target)) {
      triggerPicker(event.target)
    }
  })
}
